import React, { Component } from "react";
import { connect } from 'react-redux';
import Uppy from '@uppy/core';
import { DashboardModal, Dashboard } from '@uppy/react';
import Swal from 'sweetalert2'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Dropbox from '@uppy/dropbox';
import Instagram from '@uppy/instagram';
import Facebook from '@uppy/facebook';
import OneDrive from '@uppy/onedrive';
import Webcam from '@uppy/webcam';
import ScreenCapture from '@uppy/screen-capture';
import ImageEditor from '@uppy/image-editor';
import $ from 'jquery'
import Url from '@uppy/url';
import { Card, Button, Container, Row, Col, Form, Dropdown, Modal } from 'react-bootstrap';
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { USER_STUDIO_WALL, saveImage } from '../../../../../../../actions/sceneActions'
import { MEDIA_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { customClass, getInitialRoute } from '../../../../../../../utils'
import Tus from '@uppy/tus'
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../../../actions/constant";


const uppy = new Uppy({
    meta: { type: 'avatar' },

    autoProceed: true,
    debug: true,
    allowMultipleUploads: true,
    restrictions: {
        maxFileSize: 249857600,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/*', 'video/*']
    },
    onBeforeFileAdded: (currentFile, files) => {
        const file = uppy.getFile('uppyteamkongjpg1501851828779')
    },
    onBeforeUpload: (files) => {
        // console.log("onBeforeUpload", files)


    }
})

const uppyKey = UPPY_KEY;
const uppyBucket1 = UPPY_BUCKET;
const uppyAwsKey1 = UPPY_AWS_KEY;
const uppyAwsSecret1 = UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;


// define('WASABI_HOST', 'https://s3.us-west-1.wasabisys.com');
// define('WASABI_REGION', 'us-west-1');
// define('WASABI_CACHE_BUCKET', 'cloud.taggbox.com');
// define('WASABI_KEY', '47ABVORKG52UYE1KB28S');
// define('WASABI_SECRET_KEY', 'pcaTfeokaz28geAAns08H3yaGbOVz6ILgTptu19v');

uppy.use(GoogleDrive, { companionUrl: companionUrl })
uppy.use(Dropbox, { companionUrl: companionUrl })
uppy.use(Instagram, { companionUrl: companionUrl })
uppy.use(Facebook, { companionUrl: companionUrl })
uppy.use(OneDrive, { companionUrl: companionUrl })
uppy.use(Webcam, { companionUrl: companionUrl })
uppy.use(ScreenCapture, { companionUrl: companionUrl })
uppy.use(ImageEditor, { companionUrl: companionUrl })
// uppy.use(Tus, { companionUrl: companionUrl })
uppy.use(Url, { companionUrl: companionUrl })
uppy.use(Transloadit, {
    params: {
        auth: {
            key: uppyKey
        },
        steps: {
            store: {
                robot: '/wasabi/store',
                bucket_region: "us-west-1",
                result: true,
                bucket: uppyBucket1,
                key: uppyAwsKey1,
                secret: uppyAwsSecret1,
                path: 'media/tmpimages/${file.id}.${file.ext}',
            }
        }
    },
    waitForEncoding: true
})

class UpdateMedia extends Component {
    state = {
        selectedFile: null,
        selectedUrl: null,
        selectedName: null,
        timeInterval: 0,
        buttonDis: false,
        loader: false,
        previewURL: null
    }
   

   handleLoadedMetadata = async() => {
       var vid = await document.getElementById("myVideo").duration;
       let vidTime = parseInt(vid)
       this.setState({ timeInterval: vidTime })
       this.setState({buttonDis:isNaN(vidTime)==true ? true : false})
    };
  
    componentDidMount() {
        uppy.on('transloadit:result', (stepName, result) => {
            if (result.type == "video") {
                this.setState({
                    selectedFile: `${result.id}.${result.ext}`, selectedUrl: result.ssl_url, previewURL: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selectedName: `video-${result.original_name}`,
                    // timeInterval: result.mata.duration,
                    // postType: true
                })
            }
            else {
                this.setState({ selectedFile: `${result.id}.${result.ext}`, selectedUrl: result.ssl_url, previewURL: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selectedName: result.original_name })
            }
        })
        uppy.on('thumbnail:generated', (file, preview) => {
            this.setState({ selectedUrl: preview })
        })
    }
    onWallSave = event => {
        const { param } = this.props;
        const { selectedFile, selectedName, timeInterval, previewURL } = this.state;
        if (selectedFile && selectedFile != null) {
            this.setState({buttonDis:true,loader:true})
            this.props.saveImage(param.contentMixId, param.positionID, previewURL, selectedName, timeInterval, this.onSaveCallBack)
        }
    }
    onBack = event => {
        const { params } = this.props.match;
        const { selectedFile, selectedUrl } = this.state;
        if (selectedFile && selectedUrl) {
            Swal.fire({
                title: "Are you sure?",
                text: "Your changes have not been saved. Do you want to save before you leave the page?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Save",
                cancelButtonText: "Discard Changes",
                reverseButtons: true,
                customClass: customClass
            }).then((result) => {
                if (result.value) {

                    this.setState({buttonDis:true, loader:true })
                    const { param } = this.props;
                    const { selectedFile, selectedName, previewURL, timeInterval } = this.state;
                    if (selectedFile && selectedFile != null) {
                        this.props.saveImage(param.contentMixId, param.positionID, previewURL, selectedName, timeInterval, this.onSaveCallBack)

                    }
                    else {
                        this.props.history(`/studio/${params.wallId}`)
                        setTimeout(() => {
                            this.resetUppy();
                            this.setState({
                                selectedFile: null,
                                selectedUrl: null,
                                selectedName: null,
                                previewURL: null,
                            })
                        }, 2000)
                    }
                }
                 
                else if (result.dismiss === "cancel") {
                    this.resetUppy();
                    this.setState({
                        selectedFile: null,
                        selectedUrl: null,
                        selectedName: null,
                        previewURL: null,
                    })
                    this.props.history(`/studio/${params.wallId}`)
                }
            });
        }
        else {
            this.resetUppy();
            this.setState({
                selectedFile: null,
                selectedUrl: null,
                selectedName: null,
                previewURL: null,
            })
            this.props.history(`/studio/${params.wallId}`)
        }
    }

    onSaveCallBack = () => {

        const { params } = this.props.match;
        this.setState({buttonDis:false, loader:false })
        this.props.USER_STUDIO_WALL(params.wallId);
        Swal.fire({
            title: SUCCESS_TEXT,
            text: MEDIA_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }).then((result) => {
            this.resetUppy();
            this.setState({
                selectedFile: null,
                selectedUrl: null,
                selectedName: null,
                previewURL: null,
            })
            this.props.history(`/studio/${params.wallId}`)
        })
    }

    resetUppy=()=>{  
        const uppyTotal = window.$(".uppy-u-reset");  
        if(uppyTotal && (uppyTotal.length==1 || uppyTotal.length==2)){
            window.$(".uppy-u-reset").click();
        }
    }

    goBackNavigation=()=>{
        this.resetUppy();
        this.setState({
            selectedFile: null,
            selectedUrl: null,
            selectedName: null,
            previewURL: null,
        })
    }
    
    
    render() {
        const { match } = this.props;
        const { selectedUrl, timeInterval, selectedFile, selectedName, buttonDis, loader } = this.state;
        // console.log("timeInterval", timeInterval);
        return <>
            <NavigationHeader name="Media" goBackNavigation={this.goBackNavigation} backToNavigation={`/studio/${match.params.wallId}`}/>
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Upload Media</Form.Label>
                                                <Dashboard //uppy dashboard component
                                                    uppy={uppy}
                                                    hideUploadButton={false}
                                                    showProgressDetails={false}
                                                    autoOpenFileEditor={false}
                                                    plugins={[
                                                        "Instagram",
                                                        "GoogleDrive",
                                                        "Url",
                                                        "Webcam"
                                                    ]}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis } variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onWallSave}>Save</Button>
                                    </Card.Footer>
                                </Card>

                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {
                                                    selectedUrl ?
                                                    selectedUrl && selectedFile ? (selectedName && selectedName.includes("video-")) ? <><video
                                                        id="myVideo"
                                                        controls
                                                        autoPlay={true}
                                                        muted={true}
                                                        onDurationChangeCapture={this.handleLoadedMetadata}
                                                        style={{ width: '100%', height: '100%' }}
                                                    >
                                                        <source src={`${UPPY_BUCKET_URL}media/tmpimages/${selectedFile}`} type="video/mp4" />
                                                    <source src={`${UPPY_BUCKET_URL}media/tmpimages/${selectedFile}`} type="video/ogg" />
                                                    <source src={`${UPPY_BUCKET_URL}media/tmpimages/${selectedFile}`} type="video/mkv" />
                                                    Your browser does not support the video tag.
                                                    </video></> : <><img onLoad={()=>this.setState({buttonDis:false})} src={`${UPPY_BUCKET_URL}media/tmpimages/${selectedFile}`} style={{ width: '100%' }} /></> : null

                                                    : 
                                                    
                                                <div className="wall_view_wrapper studio-prieview"> Please select file </div> 
                                                }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </>
    }

}
const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall
    }
}
const mapDispatchToProps = dispatch => {
    return {
        saveImage: (contentMixId, positionID, postFile, name, timeInterval, callBack) => dispatch(saveImage(contentMixId, positionID, postFile, name, timeInterval, callBack)),
        USER_STUDIO_WALL: (wallID) => dispatch(USER_STUDIO_WALL(wallID)),
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(UpdateMedia);